import i18n from '@/lang/i18n'

export default function() {
    return [
        { type: 'customCheckbox' },
        {
            type: 'text',
            headerName: i18n.t('configuration.grid.code'),
            colId: 'code',
            field: 'code',
            flex: 1
        },
        {
            type: 'text',
            headerName: i18n.t('configuration.grid.name'),
            colId: 'translatedName',
            field: 'translatedName',
            flex: 1
        }
    ]
}
